import { render } from "./ChangeLog.vue?vue&type=template&id=07c1ea7e"
import script from "./ChangeLog.vue?vue&type=script&lang=ts"
export * from "./ChangeLog.vue?vue&type=script&lang=ts"
script.render = render

export default script